export const DEFAULT_WEBSITE_SEARCH_LIMIT = 500;
export const DEFAULT_WEBSITE_SEARCH_SKIP = 0;

function normalizeNonNegativeInteger ( value, fallback ) {
    const parsedValue = parseInt( value, 10 );

    if ( Number.isNaN( parsedValue ) || parsedValue < 0 ) {
        return fallback;
    }

    return parsedValue;
}

export function getWebsiteSearchParams ( search = window.location.search ) {
    const searchParams = new URLSearchParams( search || '' );

    return {
        term: String( searchParams.get( 'term' ) || '' ).trim(),
        limit: normalizeNonNegativeInteger( searchParams.get( 'limit' ), DEFAULT_WEBSITE_SEARCH_LIMIT ),
        skip: normalizeNonNegativeInteger( searchParams.get( 'skip' ), DEFAULT_WEBSITE_SEARCH_SKIP )
    };
}

export function buildWebsiteSearchUrl ( term,
                                        {
                                            limit,
                                            skip
                                        } = {} ) {
    const normalizedTerm = String( term || '' ).trim();
    const searchParams = new URLSearchParams();

    if ( normalizedTerm ) {
        searchParams.set( 'term', normalizedTerm );
    }

    if ( limit !== undefined && limit !== null ) {
        searchParams.set( 'limit', limit );
    }

    if ( skip !== undefined && skip !== null ) {
        searchParams.set( 'skip', skip );
    }

    const queryString = searchParams.toString();

    return queryString
        ? `/search?${queryString}`
        : '/search';
}
